import { useRouter } from 'next/router';
import Script from 'next/script';

interface Props {
	vacancyId: string;
	customerId: string;
}

export const MindkeyApplicationForm = ({ vacancyId, customerId }: Props) => {
	const { locale } = useRouter();
	let mindKeyLocaleFormat = locale;

	if (locale === 'da') {
		mindKeyLocaleFormat = 'da-DK';
	}

	return (
		<>
			<Script src="https://recruiting.mindkey.com/mk-recruiting-components.js" strategy="afterInteractive" />
			<mk-application-form id={vacancyId} customer-id={customerId} language={mindKeyLocaleFormat}></mk-application-form>
		</>
	);
};
